import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './18n.js';
import App from './App';

declare global {
    interface Window {
        PAYMENT_BASE_URL: string;
        NODE_ENV: string;
        BASE_URL: string;
        __REDUX_DEVTOOLS_EXTENSION__: any;
    }
}

window.BASE_URL = window.location.protocol + '//' + window.location.hostname + '/'

ReactDOM.render(
    <App />,
    document.getElementById('root'),
);
